import { Outlet } from 'react-router-dom';

// material-ui
import { Box, CssBaseline } from '@mui/material';

// project imports
import Sidebar from './Sidebar';
import { mats } from 'themes/matsTokens';

// ==============================|| MAIN LAYOUT ||============================== //
// Two columns: fixed sidebar + content. The page is the only scroll container —
// no AppBar, no inner panel scrolling.

const MainLayout = () => (
  <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: mats.surfaceApp }}>
    <CssBaseline />
    <Sidebar />
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minWidth: 0,
        backgroundColor: mats.surfacePanel,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

export default MainLayout;
